
import {
  React,
  useRef, 
  useState,
  useEffect
} from 'react';

import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Select,
  Slider, 
  Tab,
  Typography ,
  MenuItem,
  InputLabel,
  FormControl,
} from '@mui/material';

const MiscDataDisplay = (props) => {
	 const { wind_speed,
         	 last_updated,
      	   camera_temp,
           sensor_dni,
           network_status,
           sum_of_image } = props;


	const labelStyle = {
		fontFamily:"sans-serif",
		fontWeight:"lighter",
	marginTop:"5px",
	}

	const valueStyle = {
		marginTop:"3px",
		border:"1px solid grey",
		backgroundColor:"#dddddd",
		textAlign:"center",
		fontFamily:"sans-serif", fontWeight:"lighter"
	}


	return (
		<Grid
	    	style={{border:"1px solid #cccccc", padding:"2px", margin:"1px", height:"269px"}}
        	container
        	spacing={1}
    	>
	    	<Grid 
	         	item
	     		lg={12}
	            md={12}
	            xl={12}
	            xs={12}
	        >
	            <InputLabel shrink>Misc Data</InputLabel>
	        </Grid>
	        <Grid
	            item
	            xl={6}
	            lg={6}
	            md={6}
	            xs={6}
	        >
	        	<h2 style={labelStyle}>Wind speed:</h2>
	        	<h2 style={labelStyle}>Last Updated:</h2>
	        	<h2 style={labelStyle}>Camera Temp:</h2>
	        	<h2 style={labelStyle}>Sensor DNI:</h2>
	        	<h2 style={labelStyle}>Network STS:</h2>
	        	<h2 style={labelStyle}>Sum of Image:</h2>
	 		</Grid>
	 		<Grid
	            item
	            xl={6}
	            lg={6}
	            md={6}
	            xs={6}
	        >
	        	<h2 style={valueStyle}>{wind_speed.toFixed(2)}m/s</h2>
	        	<h2 style={valueStyle}>{last_updated.split(".")[0].split(" ")[1]}</h2>
	        	<h2 style={valueStyle}>{camera_temp.toFixed(2)}&deg;C</h2>
	        	<h2 style={valueStyle}>{sensor_dni.toFixed(2)}W/m<sup>2</sup></h2>
	        	<h2 style={valueStyle}>{network_status}</h2>       
	        	<h2 style={valueStyle}>{sum_of_image}</h2>       
	        </Grid>
	       
        </Grid>
	);
}


MiscDataDisplay.propTypes = {
};

export default MiscDataDisplay;